import { useState } from 'react';
import { Icon } from '@mui/material';

import './BillingGridFootnotes.scss';
import Button from '../ui/Button';

const BillingGridFootnotes = ({ footnotes }) => {
	const [footnotesExpanded, setFootnotesExpanded] =
		useState(false);

	return (
		<div className='foot-note-container'>
			<div
				className='foot-note-header'
				onClick={() =>
					setFootnotesExpanded(!footnotesExpanded)
				}
			>
				<h3 className='foot-note-title'>
					Additional Information
				</h3>

				<span>
					{!footnotesExpanded && (
						<Button className='secondary-button'>
							Show more
							<Icon className='expand-control'>
								expand_more
							</Icon>
						</Button>
					)}
					{footnotesExpanded && (
						<Button className='secondary-button'>
							Show less
							<Icon className='expand-control'>
								expand_less
							</Icon>
						</Button>
					)}
				</span>
			</div>
			{footnotesExpanded && <div>{footnotes}</div>}
		</div>
	);
};

export default BillingGridFootnotes;
